"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitlistEntriesOptionsDto = exports.ResourcesOptionsDto = exports.WaitlistEntrySummaryDto = exports.WaitlistEntryRowDto = exports.WaitlistChildRowDto = exports.WaitlistOwnerDto = exports.MassActionWaitlistEntriesDto = exports.GetWaitlistEntriesQueryDto = exports.GetWaitlistEntryQueryDto = exports.ByParentIdAndTypeDto = exports.WaitlistChildDto = exports.WaitlistEntryDto = exports.CreateWaitlistEntryDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const waitlist_enums_1 = require("../types/waitlist.enums");
class CreateWaitlistEntryDto {
}
exports.CreateWaitlistEntryDto = CreateWaitlistEntryDto;
class WaitlistEntryDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.WaitlistEntryDto = WaitlistEntryDto;
class WaitlistChildDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.WaitlistChildDto = WaitlistChildDto;
class ByParentIdAndTypeDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByParentIdAndTypeDto = ByParentIdAndTypeDto;
class GetWaitlistEntryQueryDto extends ByParentIdAndTypeDto {
}
exports.GetWaitlistEntryQueryDto = GetWaitlistEntryQueryDto;
class GetWaitlistEntriesQueryDto extends general_dto_1.PaginationSearchQuery {
}
exports.GetWaitlistEntriesQueryDto = GetWaitlistEntriesQueryDto;
waitlist_enums_1.WaitlistFilterParamsEnum.PRODUCT_IDS, waitlist_enums_1.WaitlistFilterParamsEnum.RESOURCES;
class MassActionWaitlistEntriesDto extends general_dto_1.MassActionFilterDto {
}
exports.MassActionWaitlistEntriesDto = MassActionWaitlistEntriesDto;
waitlist_enums_1.WaitlistFilterParamsEnum.PRODUCT_IDS, waitlist_enums_1.WaitlistFilterParamsEnum.RESOURCES;
class WaitlistOwnerDto {
}
exports.WaitlistOwnerDto = WaitlistOwnerDto;
class WaitlistChildRowDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.WaitlistChildRowDto = WaitlistChildRowDto;
class WaitlistEntryRowDto extends organization_dto_1.OrganizationBaseEntityDto {
}
exports.WaitlistEntryRowDto = WaitlistEntryRowDto;
class WaitlistEntrySummaryDto extends WaitlistEntryRowDto {
}
exports.WaitlistEntrySummaryDto = WaitlistEntrySummaryDto;
class ResourcesOptionsDto extends general_dto_1.SelectOptionsDto {
}
exports.ResourcesOptionsDto = ResourcesOptionsDto;
class WaitlistEntriesOptionsDto {
}
exports.WaitlistEntriesOptionsDto = WaitlistEntriesOptionsDto;
waitlist_enums_1.WaitlistFilterOptionsEnum.PRODUCTS_IDS, waitlist_enums_1.WaitlistFilterOptionsEnum.RESOURCES_IDS;
//# sourceMappingURL=waitlist.dto.js.map